import { type FC, type MouseEvent } from "react";

import { cx } from "@emotion/css";
import { Button, ButtonTypes } from "@snapchat/snap-design-system";

import { HeaderWrapper, Subheading, linkButton, overrideMarginBottom } from "../LensDestinationsTooltipHeader.styles";

import {
    DistributionRestictionsTooltipMessage,
    DistributionRestictionsTooltipOpeningMessage,
    DistributionRestrictionsHeader,
    LearnMoreDistributionRestrictions,
} from "./messages.generated";

interface LensDestinationsTooltipHeaderProps {
    onTriggerClick: (event: MouseEvent<HTMLElement>) => void;
}

export const LensDestinationsTooltipHeader: FC<LensDestinationsTooltipHeaderProps> = ({ onTriggerClick }) => {
    return (
        <HeaderWrapper className={cx("distribution-restriction-header", "tooltip-header", overrideMarginBottom)}>
            <Subheading>
                <DistributionRestrictionsHeader />
            </Subheading>
            <div>
                <DistributionRestictionsTooltipOpeningMessage />
            </div>
            <div>
                <DistributionRestictionsTooltipMessage
                    learnMore={
                        <Button type={ButtonTypes.LINK} className={linkButton} onClick={onTriggerClick}>
                            <LearnMoreDistributionRestrictions />
                        </Button>
                    }
                />
            </div>
        </HeaderWrapper>
    );
};
